module.exports = __webpack_public_path__ + "img/service1.c3af9eed.png";